import { observer } from 'mobx-react';
import React from 'react';
import { GridColumn, Notice, Separator, Text } from 'telia-front-react';
const TradeInMaxPrice = (props) => {
    const { tradeInStore: { isMaximumPriceFetching, hasMaximumPriceFetchErrored, maximumPrice, selectedDeviceId }, translate } = props;
    const renderMaximumPriceInfo = () => {
        var _a;
        return hasMaximumPriceFetchErrored ? (React.createElement(Notice, { type: "error" }, translate('tradeIn.price.to.failedRequest'))) : (React.createElement("p", null, translate('tradeIn.price.to', { maximumPrice: String((_a = maximumPrice === null || maximumPrice === void 0 ? void 0 : maximumPrice.response) === null || _a === void 0 ? void 0 : _a.price) })));
    };
    return (selectedDeviceId &&
        !isMaximumPriceFetching && (React.createElement(GridColumn, { width: ['sm-12', 'md-10'] },
        React.createElement(Text, { className: "h5 text-center" },
            renderMaximumPriceInfo(),
            React.createElement("p", { className: "h4" },
                React.createElement("strong", null, translate('tradeIn.evaluateCondition')))),
        React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }))));
};
export default observer(TradeInMaxPrice);
